import { useQuery } from "@tanstack/react-query";

import { fetchJWTPayload } from "checkout-query-client/api/get-jwt-payload";

export const useJWTPayload = <T>(payload: string) =>
  useQuery({
    queryKey: [{ scope: "jwt-payload", payload }],
    queryFn: fetchJWTPayload,
    select: (data: string) => processPayload<T>(data),
    enabled: !!payload,
  });

const processPayload = <T>(token: string) => {
  try {
    return JSON.parse(token) as T;
  } catch (e) {
    return {} as T;
  }
};

export type CheckoutIntentPayload = {
  ksi: string;
  Role: Array<string>;
  mor: string;
  od: string;
  iss: string;
  mid: string;
  oid: string;
  exp: number;
  msr: string;
  spi: string;
  iat: number;
  cid: string;
};
